import { render, staticRenderFns } from "./DashboardContent.vue?vue&type=template&id=57e166af"
import script from "./DashboardContent.vue?vue&type=script&lang=js"
export * from "./DashboardContent.vue?vue&type=script&lang=js"
import style0 from "./DashboardContent.vue?vue&type=style&index=0&id=57e166af&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57e166af')) {
      api.createRecord('57e166af', component.options)
    } else {
      api.reload('57e166af', component.options)
    }
    module.hot.accept("./DashboardContent.vue?vue&type=template&id=57e166af", function () {
      api.rerender('57e166af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/staff/dashboard_content/DashboardContent.vue"
export default component.exports